<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">W掲載元(親)設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>コマ内W掲載商品一覧</h1>
          <wj-flex-grid #dtg_GoodsList [itemsSource]="model.wPublishedGoodsList" [tabindex]="0"
            id="dtg_GoodsList" [headersVisibility]="'Column'" [isReadOnly]="true" [allowSorting]="false"
            [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'">
            <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="90" [binding]="'pCode'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="200" [binding]="'goodsName'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="180" [binding]="'standardName'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ページNO'" [width]="80" [binding]="'pageNum'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ページ名称'" [width]="234" [binding]="'pageInfo'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
        <div>
          <h1>掲載元(親)選択</h1>
          <wj-flex-grid #dtg_PageList [itemsSource]="model.wPublishedPageList" [tabindex]="0"
            id="dtg_PageList" [headersVisibility]="'Column'" [isReadOnly]="true" [allowSorting]="false"
            [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'">
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'掲載元'" [align]="'center'" [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" let-item="item">
                <input type="radio" [value]="item.id" [(ngModel)]="model.selectedPageRowIndex" id="rb_parent_{{cell.row.index}}"
                  (ngModelChange)="eventWPublishedPage_CLICKHandler(cell.row.index)" [tabindex]="0" [name]="'group' + item.id" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ページNO'" [width]="80" [binding]="'pageNum'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ページ名称'" [width]="644" [binding]="'pageInfo'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Copy" class="btn-primary" (click)="eventRegister_CLICKHandler()" [tabindex]="0"
            [disabled]="model.disabledRegister">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>